import BaseApi from '@/api/base-api'

class MerchantBranchesApi extends BaseApi {
  fetchAllBranches = (params) => {
    return this.fetchList(params)
  }
}

export default new MerchantBranchesApi('/merchants/branches')
